import classNames from 'classnames';
import { inter500, inter600 } from '@/config/fonts';
import { Stat } from '../types';
import NumberCountdown from '@/shared/components/NumberCountdown/NumberCountdown';
import { getRandomNumber } from '@/shared/utils/number';
import { useMemo } from 'react';

interface StatItemProps {
  data: Stat;
  className?: string;
  isLoading?: boolean;
}
const StatItem = ({ className, data, isLoading }: StatItemProps) => {
  const randomDuration = useMemo(() => getRandomNumber(450, 700), []);
  return (
    <div
      className={classNames(
        'h-16 w-1/2 flex-1 flex-col justify-between overflow-hidden rounded-lg py-2 pr-2 pl-4',
        {
          'bg-base-100': !!data,
        },
        className
      )}>
      {data ? (
        <>
          <div
            className={classNames(
              'stat-title text-gray-default w-[100px] overflow-hidden text-xs leading-4 text-ellipsis whitespace-nowrap',
              inter500.className
            )}
            title={data.title}>
            {data.title}
          </div>
          <div
            className={classNames(
              'stat-value text-lg leading-7',
              inter600.className,
              isLoading ? '' : data.colorClassName
            )}>
            {isLoading ? (
              <span className="loading loading-spinner loading-xs" />
            ) : (
              <>
                <NumberCountdown
                  endNumber={data.value}
                  duration={randomDuration}
                  useShortNumbers
                />
              </>
            )}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default StatItem;
